import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import { StyleEditor } from "../../../../components/BuilderComponents/BasicStyleEditor";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import ChipList from "../../../../components/BuilderComponents/ChipList";
import CustomCss from "../../../../components/BuilderComponents/CustomCss";
import SingleJobPopup from "../../../../components/BuilderComponents/JobConfigration/SingleJobPopup";
import PreFilter from "../../../../components/BuilderComponents/PreFilters/PreFilter";
import TableTreeModal from "../../../../components/BuilderComponents/TableTreeModal";
import { InlineColorMasterdataSelection } from "../../../../components/EditComponents/EditField";
import Button from "../../../../components/FormComponents/Button";
import Input from "../../../../components/FormComponents/Input";
import Label from "../../../../components/FormComponents/Label";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import axiosInstance, { handleApiError } from "../../../../services/axiosService";
import BlockTiles from "../../ChartRenderer/BlockTiles";
import EditActions from "../Desktop/RecordsViewEdit/EditActions";
import EditRecordviewOnScreenFilters from "../Desktop/RecordsViewEdit/EditRecordviewOnScreenFilters";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { toastError } from "../../../../utils/toastUtils";

const MobileRecordEditSection = ({ tableRef }) => {
  const { recordsviewLayout, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();
  const settingTiles = (data) => {
    const copyObj = { ...recordsviewLayout };
    copyObj.tiles = data;
    setRecordsviewLayout(copyObj);
  };

  const settingActions = (data) => {
    const newObj = JSON.parse(JSON.stringify(recordsviewLayout));
    newObj.multi_select_custom_actions = data;
    setRecordsviewLayout(newObj);
  };

  const callbackFunctionOfOwnerAnePreFilter = (value, data) => {
    const newLayout = JSON.parse(JSON.stringify(recordsviewLayout));
    newLayout[value] = data;
    setRecordsviewLayout(newLayout);
  };
  const tabData = [
    {
      label: "Filters",
      content: <MobileFilters />
    },
    {
      label: "Pre Filters",
      content: (
        <PreFilter
          preFilters={recordsviewLayout.pre_filters}
          setPreFilters={(data) => callbackFunctionOfOwnerAnePreFilter("pre_filters", data)}
          ownerPreFilters={recordsviewLayout.owner_pre_filters}
          setOwnerPreFilters={(data) => callbackFunctionOfOwnerAnePreFilter("owner_pre_filters", data)}
          table_id={applicationBlockData.config.layout.table_id}
          prefiltersJoinedBy={recordsviewLayout?.prefilters_joined_by}
          setPrefiltersJoinedBy={(data) => callbackFunctionOfOwnerAnePreFilter("prefilters_joined_by", data)}
          type="recordview"
        />
      )
    },
    {
      label: "Tiles",
      content: (
        <BlockTiles
          tiles={recordsviewLayout.tiles}
          setTiles={settingTiles}
          table_id={applicationBlockData.config.layout.table_id}
          allTableColumns={tableRef.current}
        />
      )
    },
    {
      label: "Actions",
      content: (
        <EditActions
          actions={recordsviewLayout.multi_select_custom_actions}
          setActions={settingActions}
          device={applicationBlockData.device}
          tableId={applicationBlockData.config.layout.table_id}
          elements={[applicationBlockData]}
          tableType={applicationBlockData?.table_type || "statemachine"}
        />
      )
    },
    {
      label: "General",
      content: <EditGeneralData tableRef={tableRef} />
    },
    {
      label: "Style",
      content: <EditRvStyles recordsviewLayout={recordsviewLayout} setRecordsviewLayout={setRecordsviewLayout} />
    }
  ];

  return (
    <div>
      <BuilderTabs tabs={tabData} />
    </div>
  );
};

// const MobileFilters = ({ nonSelectedFilter, setNonSelectedFilter }) => {
export const MobileFilters = () => {
  const { recordsviewLayout, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();

  const handleChangeFilters = (data) => {
    let layoutCopy = { ...recordsviewLayout };
    layoutCopy.onscreen_filters = data;
    setRecordsviewLayout(layoutCopy);
  };

  return (
    <div className="edit_popup_inside">
      {/* <FilterRenderer
        tableId={applicationBlockData.config.layout.table_id}
        filters={recordsviewLayout.onscreen_filters}
        updateFilters={handleChangeFilters}
      /> */}
      <EditRecordviewOnScreenFilters
        filters={recordsviewLayout.onscreen_filters}
        saveFilters={handleChangeFilters}
        tableId={applicationBlockData.config.layout.table_id}
        tableType={applicationBlockData.table_type || "statemachine"}
      />
    </div>
  );
};

export const EditGeneralData = ({ tableRef }) => {
  const { recordsviewLayout, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();

  const popupPositionOptions = [
    { id: "center", name: "center" },
    { id: "bottom", name: "bottom" }
  ];
  const styleTypeOptions = [
    { id: "none", name: "None" },
    { id: "static_color", name: "Static color" },
    { id: "dynamic_color", name: "Dynamic color" }
  ];

  const [openColorPicker, setOpenColorPicker] = useState(false);
  // const [openDynamicColorPicker, setOpenDynamicColorPicker] = useState("");
  const [selectedDynamicField, setSelectedDynamicField] = useState(
    recordsviewLayout?.style?.dynamic_bar_color?.selected_dynamic_field || null
  );
  const [dynamicColorPairs, setDynamicColorPairs] = useState(
    recordsviewLayout?.style?.dynamic_bar_color?.color_config || [{ value: "", color: "" }]
  );
  const [selectedStyleType, setSelectedStyleType] = useState("");
  const [isColorOpen, setIsColorOpen] = useState();
  const [allJobs, setAllJobs] = useState([]);
  const templateObject = {};
  const [isTabFilterOpen, setIsTabFilterOpen] = useState(false);

  const fetchAllTemplatesAndJobs = async () => {
    try {
      const { data } = await axiosInstance.get(`/jobs/filter/?places=details_view&elements=button`);
      setAllJobs(data);
    } catch (error) {
      handleApiError(error);
    }
  };
  const handleTitle = (e) => {
    const layoutCopy = { ...recordsviewLayout };
    let { name, value } = e.target;
    if (name === "data_limit") {
      value = +value;
    }
    layoutCopy[name] = value;
    setRecordsviewLayout(layoutCopy);
  };

  const handleTableSerchShow = () => {
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy.search = layoutCopy.search === true ? false : true;
    setRecordsviewLayout(layoutCopy);
  };

  const handleStaticColor = (color) => {
    let layoutCopy = { ...recordsviewLayout };
    layoutCopy.style.static_bar_color.color = color;
    setRecordsviewLayout(layoutCopy);
  };

  const handleSelectedStyle = (value) => {
    let layoutCopy = { ...recordsviewLayout };
    layoutCopy.style = layoutCopy.style || {};
    layoutCopy.style.static_bar_color = layoutCopy.style.static_bar_color || {};
    layoutCopy.style.dynamic_bar_color = layoutCopy.style.dynamic_bar_color || {};
    if (value === "static_color") {
      layoutCopy.style.static_bar_color.show_color = true;
      layoutCopy.style.dynamic_bar_color.show_dynamic_color = false;
    } else if (value === "dynamic_color") {
      layoutCopy.style.static_bar_color.show_color = false;
      layoutCopy.style.dynamic_bar_color.show_dynamic_color = true;
    } else {
      layoutCopy.style.static_bar_color.show_color = false;
      layoutCopy.style.dynamic_bar_color.show_dynamic_color = false;
    }
    setRecordsviewLayout(layoutCopy);
    setSelectedStyleType(value);
  };

  const handleColorPicker = () => {
    setOpenColorPicker(!openColorPicker);
  };

  const handleSelectedDynamicField = (data) => {
    let layoutCopy = { ...recordsviewLayout };
    setSelectedDynamicField(data);
    layoutCopy.style.dynamic_bar_color.selected_dynamic_field = data;
    setDynamicColorPairs([{ value: "", color: "" }]);
    setRecordsviewLayout(layoutCopy);
    setIsColorOpen(false);
  };
  const handleJobTriggerData = (data) => {
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy.on_row_action = data;
    setRecordsviewLayout(layoutCopy);
  };

  const removeTabFilter = (e) => {
    e.stopPropagation();
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy.filter_layout.filter_field = {};
    setRecordsviewLayout(layoutCopy);
  };
  const handleTabFilterField = (data) => {
    const { id, data_type, field_type, type, display } = data;
    const modifiedData = { id, data_type, field_type, type, display };
    const layoutCopy = { ...recordsviewLayout };
    if (!layoutCopy.filter_layout) {
      layoutCopy.filter_layout = {
        filter_field: "",
        style_type: ""
      };
    }
    layoutCopy.filter_layout.filter_field = modifiedData;
    setRecordsviewLayout(layoutCopy);
    setIsTabFilterOpen(false);
  };

  const handleFilterStyleType = (data) => {
    const layoutCopy = { ...recordsviewLayout };
    if (!layoutCopy.filter_layout) {
      layoutCopy.filter_layout = {
        filter_field: "",
        style_type: ""
      };
    }
    layoutCopy.filter_layout.style_type = data;
    setRecordsviewLayout(layoutCopy);
    setIsTabFilterOpen(false);
  };
  const handleUpdatePosition = (value) => {
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy.popup_position = value;
    setRecordsviewLayout(layoutCopy);
  };

  // const handleInputChange = (index, key, inputValue) => {
  //   const updatedPairs = [...dynamicColorPairs];
  //   updatedPairs[index][key] = inputValue;
  //   setDynamicColorPairs(updatedPairs);
  // };

  // const handleDeletePair = (index) => {
  //   const updatedPairs = [...dynamicColorPairs];
  //   updatedPairs.splice(index, 1);
  //   setDynamicColorPairs(updatedPairs);
  // };

  // const handleAddPair = () => {
  //   const updatedPairs = [...dynamicColorPairs, { value: "", color: "" }];
  //   setDynamicColorPairs(updatedPairs);
  // };

  // const handleDynamicColorPicker = (index) => {
  //   if (index === openDynamicColorPicker) {
  //     setOpenDynamicColorPicker("");
  //   } else {
  //     setOpenDynamicColorPicker(index);
  //   }
  // };
  // const handleFieldClassName = (heading, selectedValue) => {
  //   const updatedClassName = { ...recordsviewLayout.style.className, [heading]: selectedValue };
  //   const updatedStyle = { ...recordsviewLayout.style, className: updatedClassName };
  //   setRecordsviewLayout({
  //     ...recordsviewLayout,
  //     style: updatedStyle
  //   });
  // };
  // const handleFieldInlineStyle = (data) => {
  //   const updatedStyle = { ...recordsviewLayout.style, inline_style: data };
  //   setRecordsviewLayout({
  //     ...recordsviewLayout,
  //     style: updatedStyle
  //   });
  // };

  const handleChangeHiddenColumn = (data) => {
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy.hidden_columns = data;
    setRecordsviewLayout(layoutCopy);
  };

  const handleSelectedDynamicFieldColorConfig = (key, data) => {
    let layoutCopy = JSON.parse(JSON.stringify(recordsviewLayout));
    if (key === "color_config_type") {
      layoutCopy.style.dynamic_bar_color.color_config_type = data;
    }
    if (key === "color_master_data") {
      layoutCopy.style.dynamic_bar_color.master_data_id = data;
    }
    if (key === "colorif") {
      layoutCopy.style.dynamic_bar_color.color_config = data;
    }
    setRecordsviewLayout(layoutCopy);
  };

  useEffect(() => {
    setSelectedStyleType(
      recordsviewLayout?.style?.static_bar_color?.show_color === true
        ? "static_color"
        : recordsviewLayout?.style?.dynamic_bar_color?.show_dynamic_color === true
          ? "dynamic_color"
          : "none"
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationBlockData.id]);

  useEffect(() => {
    let layoutCopy = { ...recordsviewLayout };
    layoutCopy.style = layoutCopy.style || {};
    layoutCopy.style.dynamic_bar_color = layoutCopy.style.dynamic_bar_color || {};
    layoutCopy.style.dynamic_bar_color.selected_dynamic_field = selectedDynamicField;
    layoutCopy.style.dynamic_bar_color.color_config = dynamicColorPairs;
    setRecordsviewLayout(layoutCopy);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDynamicField, dynamicColorPairs]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchAllTemplatesAndJobs();
      } catch (error) {
        handleApiError(error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterOptions = [
    { name: "Tab", id: "tab" },
    { name: "Button", id: "button" }
  ];
  return (
    <>
      <div
        className="p_4 builder_form overflow_scroll"
        style={{
          height: "calc(100vh - 96px)"
        }}
      >
        <div className="d_flex align_center gap_3">
          <Input
            label="Title"
            value={recordsviewLayout.title}
            name="title"
            placeholder="Type Here"
            onChange={handleTitle}
          />
          <Input
            label="Enter Data Limit"
            type="number"
            name="data_limit"
            value={recordsviewLayout.data_limit || 50}
            placeholder="Enter data limit"
            onChange={handleTitle}
          />
        </div>

        <div className="d_flex gap_3">
          <div className="flex_column gap_1 w_50">
            <Label>Select Tab Filter</Label>
            <div className="builder_input d_flex justify_between" onClick={() => setIsTabFilterOpen(true)}>
              {recordsviewLayout.filter_layout?.filter_field.id
                ? `${tableRef.current[recordsviewLayout.filter_layout.filter_field.id].prefix}.${
                    tableRef.current[recordsviewLayout.filter_layout.filter_field.id].display
                  }`
                : "Select Tab Filter"}
              {recordsviewLayout.filter_layout?.filter_field && (
                <ButtonActionIcon size="xsm" type="delete" title="Remove tab filter" onClick={removeTabFilter} />
              )}
            </div>
          </div>

          {recordsviewLayout.filter_layout?.filter_field && recordsviewLayout.filter_layout?.filter_field?.id && (
            <div className="w_50">
              <SingleSelectBox
                selectedData={recordsviewLayout.filter_layout.style_type}
                options={filterOptions}
                onChange={(obj) => handleFilterStyleType(obj.id)}
                label="Select Filter Style"
                placeholder="Select Style"
              />
            </div>
          )}
        </div>

        <BuilderModal isOpen={isTabFilterOpen} onClose={() => setIsTabFilterOpen(false)} modalName={"Add Tab Filter"}>
          <TableTreeModal
            callbackFunction={handleTabFilterField}
            tableId={applicationBlockData.config.layout.table_id}
            selectedFile={
              recordsviewLayout?.filter_layout?.filter_field?.id &&
              tableRef?.current?.[recordsviewLayout.filter_layout.filter_field.id]?.id
                ? tableRef.current[recordsviewLayout.filter_layout.filter_field.id].id
                : ""
            }
          />
        </BuilderModal>

        <SingleJobPopup
          config={recordsviewLayout.on_row_action}
          templateObject={templateObject}
          allJobs={allJobs}
          smId={applicationBlockData.config.layout.table_id}
          device={applicationBlockData.device}
          onChange={handleJobTriggerData}
          label="On Row Action"
        />
        {recordsviewLayout?.on_row_action?.job_id &&
          recordsviewLayout?.on_row_action?.job_template === "show_detailsview_popup" && (
            <div className="builder_form">
              <SingleSelectBox
                selectedData={recordsviewLayout?.popup_position}
                options={popupPositionOptions}
                onChange={(obj) => handleUpdatePosition(obj.id)}
                placeholder="select"
                label="Select Detailview Position"
              />
            </div>
          )}

        <HiddenColumns
          columns={recordsviewLayout.hidden_columns || []}
          handleChange={handleChangeHiddenColumn}
          tableId={recordsviewLayout.table_id}
        />
        <div className="recordsview_toggle_outer">
          <Label className="builder_label">Show search box</Label>
          <div className={`toggle_switch ${recordsviewLayout.search ? "active" : ""}`} onClick={handleTableSerchShow}>
            <div className="toggle_slider"></div>
          </div>
        </div>
        <SingleSelectBox
          selectedData={selectedStyleType}
          options={styleTypeOptions}
          onChange={(obj) => handleSelectedStyle(obj.id)}
          containerClassName={"w_50"}
          placeholder="Select style type"
          label="Select barstyle type"
        />
        {recordsviewLayout?.style?.static_bar_color?.show_color === true && (
          <div className="color_input_container w_50">
            <Input
              label="Change Static Color"
              placeholder="Color"
              value={recordsviewLayout.style.static_bar_color?.color || "#4A1FB8"}
              onChange={(e) => handleStaticColor(e.target.value)}
              inputBoxStyle={{ borderLeft: `8px solid ${recordsviewLayout.style.static_bar_color?.color}` }}
            />
            <MaterialIcon
              name={openColorPicker ? "close" : "colors"}
              className="color_icon"
              onClick={handleColorPicker}
            />
            {openColorPicker && (
              <div className="color_picker_container">
                <SketchPicker
                  color={recordsviewLayout.style.static_bar_color?.color || "#4A1FB8"}
                  onChange={(e) => handleStaticColor(e.hex.toUpperCase())}
                />
              </div>
            )}
          </div>
        )}
        {recordsviewLayout?.style?.dynamic_bar_color?.show_dynamic_color === true && (
          <>
            <Label>Select the field</Label>
            <Button className="mr_auto" variant="secondary" onClick={() => setIsColorOpen(true)}>
              Add
            </Button>
            <BuilderModal isOpen={isColorOpen} onClose={() => setIsColorOpen(false)} modalName={"Add Pre-Filter"}>
              <TableTreeModal
                callbackFunction={handleSelectedDynamicField}
                tableId={applicationBlockData.config.layout.table_id}
              />
            </BuilderModal>
            {selectedDynamicField !== null && (
              <>
                <p className="config_child_header_title">
                  Color config -
                  {/* {applicationBlockData?.config?.layout?.style?.dynamic_bar_color?.selected_dynamic_field?.display} */}
                  {selectedDynamicField?.display}
                </p>
                <InlineColorMasterdataSelection
                  colorConfigType={recordsviewLayout?.style?.dynamic_bar_color?.color_config_type || "inline"}
                  handleEditElementData={(label, value) => handleSelectedDynamicFieldColorConfig(label, value)}
                  colorMasterData={recordsviewLayout?.style?.dynamic_bar_color?.master_data_id || ""}
                  colorIf={recordsviewLayout?.style?.dynamic_bar_color?.color_config}
                />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export const EditRvStyles = ({ recordsviewLayout, setRecordsviewLayout }) => {
  const updateClassAndInlineStyle = (data) => {
    const copyRecordviewLayout = JSON.parse(JSON.stringify(recordsviewLayout));
    const updatedStyle = {
      ...copyRecordviewLayout.style,
      className: data.classData,
      inline_style: data.inlineData
    };
    setRecordsviewLayout({
      ...copyRecordviewLayout,
      style: updatedStyle
    });
  };

  const handleCustomCss = (e) => {
    const { name, value } = e.target;
    const updatedStyle = { ...recordsviewLayout.style, [name]: value };
    setRecordsviewLayout({
      ...recordsviewLayout,
      style: updatedStyle
    });
  };
  return (
    <div
      className="flex_row p_4 overflow_scroll gap_3"
      style={{
        height: "calc(100vh - 96px)"
      }}
    >
      <div className="w_50">
        <StyleEditor
          styleObj={{
            border: true,
            border_radius: true,
            shadow: true,
            color: true,
            background_color: true
          }}
          value={{
            classData: recordsviewLayout?.style.className || {},
            inlineData: recordsviewLayout?.style.inline_style || {}
          }}
          callbackFunction={updateClassAndInlineStyle}
        />
      </div>
      <CustomCss
        bodyClass={"w_50"}
        value={{
          custom_css: recordsviewLayout?.style.custom_css || "",
          custom_id: recordsviewLayout?.style.custom_id || "",
          custom_classname: recordsviewLayout?.style.custom_classname || ""
        }}
        onChange={handleCustomCss}
      />
    </div>
  );
};

const HiddenColumns = ({ columns, handleChange, tableId, label = "Hidden Columns" }) => {
  const [isHiddenColOpen, setIsHiddenColOpen] = useState(false);
  // const { recordsviewLayout, setRecordsviewLayout } = useAppBlocksContext();

  const handleAddHiddenCols = (data) => {
    const { id, data_type, field_type, type, display } = data;
    const modifiedData = { id, data_type, field_type, type, display };
    const alreadyExists = columns.some((col) => col.id === id);
    if (alreadyExists) {
      toastError("Already exists");
      return;
    }
    const copyColumns = [...columns, modifiedData];
    handleChange(copyColumns);
  };

  const removeHiddenCol = (chip) => {
    const copyColumns = [...columns];
    const updatedHiddenColumns = copyColumns.filter((hiddenChip) => hiddenChip.id !== chip.id);
    handleChange(updatedHiddenColumns);
  };

  return (
    <div>
      {columns && columns.length === 0 && (
        <div className="d_flex align_center p_3 gap_2 font_weight_semibold" style={{ width: "172px" }}>
          <div>{label}</div>
          <Button
            className="mr_auto"
            variant="secondary"
            style={{ width: "24px", height: "24px" }}
            size="small"
            onClick={() => setIsHiddenColOpen(true)}
          >
            <MaterialIcon name="add" style={{ fontSize: "12px" }} />
          </Button>
        </div>
      )}
      {columns && columns.length > 0 && (
        <>
          <div className="position_relative">
            <Label
              className="position_absolute font_weight_semibold"
              style={{
                top: "-12px",
                left: "20px",
                padding: "4px"
              }}
            >
              {label}
            </Label>
          </div>
          <div className="recordview_summary_container d_flex justify_center gap_2">
            <ChipList chips={columns} labelKey={["display"]} removeChip={removeHiddenCol} />
            <div className="">
              {" "}
              <Button className="mr_auto" variant="secondary" size="small" onClick={() => setIsHiddenColOpen(true)}>
                +
              </Button>
            </div>
          </div>
        </>
      )}
      <BuilderModal isOpen={isHiddenColOpen} onClose={() => setIsHiddenColOpen(false)} modalName={"Add Hidden Column"}>
        <TableTreeModal callbackFunction={handleAddHiddenCols} tableId={tableId} />
      </BuilderModal>
    </div>
  );
};

export { HiddenColumns };

export default MobileRecordEditSection;
